import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'

import componentStyles from 'assets/theme/components/cards/cards/card-button.js'

const useStyles = makeStyles(componentStyles)

function ErrorCard(props) {
    const classes = useStyles()

    function reload() {
        window.location.reload()
    }
    
    return (
        <>
            <Card className={classes.cardRoot} style={{width: '400px'}}>
                <CardContent>
                    <Box display='flex' flexDirection='column' justify='center' alignItems='center'>
                        <Box
                            component={Typography}
                            variant='h3'
                            marginBottom='1rem!important'
                            textAlign='center'
                        >
                            Error Loading Page
                        </Box>

                        <Box
                            component='p'
                            marginBottom='1rem'
                            fontWeight='300'
                            lineHeight='1.7'
                            fontSize='1rem'
                            marginTop='0'
                            textAlign='center'
                        >
                            There was error loading this page, please try again.
                        </Box>
                        

                        <Button variant='contained' color='primary' onClick={() => reload()}>
                            Reload
                        </Button>
                    </Box>
                </CardContent>
            </Card>
        </>
    );
}

export default ErrorCard